export default "__VITE_ASSET__Bggo0yBd__"